<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-content">
      <h2>{{ title }}</h2>  <!-- タイトルを表示 -->

      <!-- 検索条件入力フォーム -->
      <form @submit.prevent="search">
        <div class="form-group">
          <label for="keyword">検索キーワード</label>
          <input v-model="searchData.keyword" type="text" id="keyword" :placeholder="placeholderText" @click.stop>
          <label>
            <input type="radio" value="exact" v-model="searchMethod"> 完全一致
            <input type="radio" value="" v-model="searchMethod"> あいまい検索
          </label>
          <label>　</label>
          <button type="submit" class="first">検索</button>
       </div>
      </form>

      <!-- 検索結果のテーブル表示 -->
      <div v-if="results && results.length > 0">
        <h3>検索結果</h3>
        <div class="table-container">
          <table>
            <thead>
              <tr>
                <th>選択</th>
                <!-- displayColumns を使用してヘッダーを生成 -->
                <th v-for="column in displayColumns" :key="column.key">
                  {{ column.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="result in results" :key="result.gyouseiId || result.userid">
                <td>
                  <!-- ラジオボタンで選択 -->
                  <input
                    type="radio"
                    :value="result"
                    v-model="selectedResult"
                    name="searchResult"
                    @click.stop
                    @dblclick.prevent
                  />
                </td>
                <!-- displayColumns を使用してデータを生成 -->
                <td v-for="column in displayColumns" :key="column.key">
                  {{ result[column.key] }}
                </td>
              </tr>
          </tbody>
          </table>
        </div>
      </div>

      <!-- モーダルの操作ボタン -->
      <div class="modal-actions">
        <button @click="closeModal" class="second">閉じる</button>
        <button
          @click="selectResult"
          class="usual"
          :disabled="!selectedResult">選択 </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'; // axiosをインポート
axios.defaults.timeout = process.env.VUE_TIMEOUT||5000;

export default {
  props: {
    caller: {
      type: String,
      required: true, // 呼び出し元を必ず指定する
    },
    isVisible: Boolean,       // モーダルの表示状態
    displayColumns: {
      type: Array,
      required: true, // 必須プロパティ
    },
    title: {
      type: String,
      required: true, // 親から必須で渡されるタイトル
    },
  },
  data() {
    return {
      searchData: {
        keyword: '',  // 検索キーワード
      },              // 検索条件データ（親から渡されたカテゴリに基づいて動的に作成）
      searchMethod: '', // デフォルトは部分一致
      results: [],             // 検索結果
      selectedResult: null,    // 選択された検索結果
      categoryLabels: {
        id: '利用者ID',
        nameKanji: '利用者氏名(漢字)',
        nameKana: '利用者氏名(カナ)',
        section: '利用者区分',
        gyouseiId: '行政機関ID',
        gyouseiName: '行政機関名称',
		kana: '行政機関（ｶﾅ）',
        gyouseiKbn: '行政機関区分'
      },                       // 各カテゴリに対するラベル（日本語）
    };
  },
  computed: {
    placeholderText() {
      // 変数に "を入力してください" を付加
      const label = this.caller === 'user' ? '利用者名' : '行政機関名';
      return `${label}を入力してください`;
    },
    filteredCategoryLabels() {
      return this.targetData.reduce((labels, key) => {
        if (this.categoryLabels[key]) {
          labels[key] = this.categoryLabels[key];
        }
        return labels;
      }, {});
    },
    filteredResults() {
      return this.results.map(result => {
        const filteredResult = {};
        this.targetData.forEach(key => {
          if (result[key] !== undefined) {
            filteredResult[key] = result[key];
          }
        });
        return filteredResult;
      });
    }
  },
  mounted() {
    this.results = [];
  },
  watch: {
    categories(newCategories) {
      this.resetSearchData(newCategories);  // categories変更時にsearchDataをリセット
    },
  },
  methods: {
    closeModal() {
      // モーダルを閉じるときに状態をリセット
      this.$emit('close');
      // 検索条件のリセット
      this.searchData.keyword = '';
      this.searchMethod = ''; // デフォルトは部分一致
      // 選択された結果をリセット
      this.selectedResult = null;
      // 検索結果のリセット
      this.results = [];
    },
    resetSearchData(categories) {
      this.searchData = { keyword: '' }
      // categoriesの内容に基づいてsearchDataを初期化
      categories.forEach(category => {
        this.searchData[category] = '';
      });
    },
    async search() {
      try {
        let searchResults;
        let targetKey, secondKey;

        // 呼び出し元に応じて検索対象のキーを設定
        if (this.caller === 'user') {
          searchResults = await this.fetchUserResults();
          targetKey = 'nameKanji'; // 利用者情報のキー
          secondKey = 'nameKana';  // 利用者情報のキー
        } else {
          searchResults = await this.fetchAgencyResults();
          targetKey = 'name';  // 行政機関のキー
          secondKey = 'kana';  // 行政機関のキー
		  // 何故か名前が違う注意（gyouseiName⇒name）
		  // 一覧にカナもない・・・バグる為の仕様としか思えない
        }

        const keyword = (this.searchData.keyword || '').trim(); // 空白を除去し、空のキーワードに対処

        // キーワードが空の場合は全件表示
        if (!keyword) {
          this.results = searchResults;
          return;
        }

        // 検索結果をフィルタリング
        this.results = searchResults.filter(result => {
		  var hit = false;
          if (this.searchMethod === 'exact') {
          	if (result[targetKey])
            	hit = (result[targetKey] = keyword);
          	if (result[secondKey])
            	hit |= (result[secondKey] = keyword);
            return hit;
          } else {
          	if (result[targetKey])
            	hit = result[targetKey].toString().includes(keyword);
          	if (result[secondKey])
            	hit |= result[secondKey].toString().includes(keyword);
            return hit;
          }
        });
      } catch (error) {
        console.error('検索中にエラーが発生しました:', error);
      }
    },

    async fetchUserResults() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId");
      const section = localStorage.getItem("section");
      const directAdminAgency = localStorage.getItem("directAdminAgency");

      let adminAgency = null;
      if (!section.startsWith("00")) {
        // システム管理者以外は本人の直属行政機関を検索条件に含める
        adminAgency = directAdminAgency;
      }

      try {
        // リクエストボディに id を含める・・・意味不明？？？
        const requestData = { id: userId, section: section, adminAgency: adminAgency };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/userRegister/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        
        // 新しいトークンがレスポンスヘッダーに含まれている場合
        const newToken = response.headers.get('Authorization');
        if (newToken) {
            localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
        }
        return response.data.data;
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
      }
    },

    async fetchAgencyResults() {
      const token = localStorage.getItem("jwtToken");
      const userId = localStorage.getItem("userId"); // ローカルストレージから userId を取得

      try {
        // リクエストボディに id を含める
        const requestData = { id: userId };

        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/api/addminAgencyRegister/getList`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log(response);
        
        // 新しいトークンがレスポンスヘッダーに含まれている場合
        const newToken = response.headers.get('Authorization');
        if (newToken) {
            localStorage.setItem('jwtToken', newToken.replace('Bearer ', ''));
        }

        return response.data.data;
      } catch (error) {
        alert("タイムアウトです、ログインしなおしてください");
        this.$router.push({ name: 'Login' });
        //alert(`エラーが発生しました（エラーコード：${error.response.status}）`);
      }
    },
    selectResult() {
      if (this.selectedResult) {
        // 親コンポーネントに選択されたデータを通知
        this.$emit('select', this.selectedResult);

        // モーダルを閉じる前にデータをリセット
        this.selectedResult = null;
        this.results = [];
        this.closeModal();
      } else {
        alert("データを選択してください"); // 選択がない場合の警告
      }
    },
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 90%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background: #d4f1c5;
  padding: 20px;
  border-radius: 5px;
  width: 70%;
}

.modal-content form {
    border: 2px solid #ccc;
    border-radius: 8px;
    font-size: 16px;
    max-height: 60vh;
    overflow-y: auto;
    padding: 10px;
}

.modal-actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.form-group {
  margin-bottom: 15px;
}

.button-group {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 左右に要素を配置 */
  gap: 10px;
}

.search-button {
  margin-left: auto; /* 右端に配置 */
}

.table-container {
    max-height: 200px;  /* 高さを指定してスクロール領域に */
    overflow-y: auto;   /* 垂直方向にスクロール可能に */
    margin-top: 20px;
    background-color: #ebf6f7;
    border: 1px solid #ddd;
    border-radius: 8px;
    max-height: 390px; /* 高さを調整 */
    overflow-y: auto; /* 縦にスクロール可能 */
}

.table-container thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: #00E600; /* 背景色を指定 */
}

.table-container th, .table-container td {
    padding: 8px;
    text-align: center;
    border: 1px solid #ddd; /* 各セルの枠線 */
    font-size: inherit; /* 親要素のフォントサイズを継承 */
}

.table-container th {
    background-color: #00E600;
}

.table-container td {
    padding: 5px;
}

.table-container td input[type="radio"] {
  vertical-align: middle; /* ラジオボタン自体の中央揃え */
  margin: 0; /* 不要な余白を削除 */
  position: relative; /* ポジショニングを確保 */
  top: 0; /* デフォルトのずれを修正 */
  transform: translateY(0); /* 微調整をリセット */
}

.usual { background-color: #17a2b8; }
.first { background-color: #28a745; }
.alert { background-color: #ff6347; }
.second { background-color: #6c757d; }
</style>
